var map = {
	"./aparat.png": "./src/assets/images/platforms/aparat.png",
	"./bilibili.svg": "./src/assets/images/platforms/bilibili.svg",
	"./boomstream.svg": "./src/assets/images/platforms/boomstream.svg",
	"./breakerstv.svg": "./src/assets/images/platforms/breakerstv.svg",
	"./colored/bilibili.svg": "./src/assets/images/platforms/colored/bilibili.svg",
	"./colored/boomstream.svg": "./src/assets/images/platforms/colored/boomstream.svg",
	"./colored/breakerstv.svg": "./src/assets/images/platforms/colored/breakerstv.svg",
	"./colored/custom.svg": "./src/assets/images/platforms/colored/custom.svg",
	"./colored/cybergame.svg": "./src/assets/images/platforms/colored/cybergame.svg",
	"./colored/discord.png": "./src/assets/images/platforms/colored/discord.png",
	"./colored/discord.svg": "./src/assets/images/platforms/colored/discord.svg",
	"./colored/djlive.png": "./src/assets/images/platforms/colored/djlive.png",
	"./colored/dlive.svg": "./src/assets/images/platforms/colored/dlive.svg",
	"./colored/facebook-live.svg": "./src/assets/images/platforms/colored/facebook-live.svg",
	"./colored/gg.svg": "./src/assets/images/platforms/colored/gg.svg",
	"./colored/instagib.svg": "./src/assets/images/platforms/colored/instagib.svg",
	"./colored/lahzenegar.svg": "./src/assets/images/platforms/colored/lahzenegar.svg",
	"./colored/linkedin.svg": "./src/assets/images/platforms/colored/linkedin.svg",
	"./colored/liveedu.svg": "./src/assets/images/platforms/colored/liveedu.svg",
	"./colored/livehouse.svg": "./src/assets/images/platforms/colored/livehouse.svg",
	"./colored/livestream.svg": "./src/assets/images/platforms/colored/livestream.svg",
	"./colored/meridix.svg": "./src/assets/images/platforms/colored/meridix.svg",
	"./colored/mixcloud.svg": "./src/assets/images/platforms/colored/mixcloud.svg",
	"./colored/mixer.svg": "./src/assets/images/platforms/colored/mixer.svg",
	"./colored/mobcrush.svg": "./src/assets/images/platforms/colored/mobcrush.svg",
	"./colored/nimotv.png": "./src/assets/images/platforms/colored/nimotv.png",
	"./colored/nimotv.svg": "./src/assets/images/platforms/colored/nimotv.svg",
	"./colored/now.svg": "./src/assets/images/platforms/colored/now.svg",
	"./colored/periscope.png": "./src/assets/images/platforms/colored/periscope.png",
	"./colored/periscope.svg": "./src/assets/images/platforms/colored/periscope.svg",
	"./colored/phonelivestreaming.svg": "./src/assets/images/platforms/colored/phonelivestreaming.svg",
	"./colored/picartotv.svg": "./src/assets/images/platforms/colored/picartotv.svg",
	"./colored/sportscastr.svg": "./src/assets/images/platforms/colored/sportscastr.svg",
	"./colored/steam.svg": "./src/assets/images/platforms/colored/steam.svg",
	"./colored/switchboard.svg": "./src/assets/images/platforms/colored/switchboard.svg",
	"./colored/thetatv.svg": "./src/assets/images/platforms/colored/thetatv.svg",
	"./colored/trovo.svg": "./src/assets/images/platforms/colored/trovo.svg",
	"./colored/twitch.svg": "./src/assets/images/platforms/colored/twitch.svg",
	"./colored/twitter.svg": "./src/assets/images/platforms/colored/twitter.svg",
	"./colored/ustream.svg": "./src/assets/images/platforms/colored/ustream.svg",
	"./colored/vaperstv.svg": "./src/assets/images/platforms/colored/vaperstv.svg",
	"./colored/vaughnlive.svg": "./src/assets/images/platforms/colored/vaughnlive.svg",
	"./colored/vimeo-white-12dfb0dc.svg": "./src/assets/images/platforms/colored/vimeo-white-12dfb0dc.svg",
	"./colored/vimeo.svg": "./src/assets/images/platforms/colored/vimeo.svg",
	"./colored/vimmtv.png": "./src/assets/images/platforms/colored/vimmtv.png",
	"./colored/vimmtv.svg": "./src/assets/images/platforms/colored/vimmtv.svg",
	"./colored/vk.png": "./src/assets/images/platforms/colored/vk.png",
	"./colored/vk.svg": "./src/assets/images/platforms/colored/vk.svg",
	"./colored/webtv.svg": "./src/assets/images/platforms/colored/webtv.svg",
	"./colored/younow.svg": "./src/assets/images/platforms/colored/younow.svg",
	"./colored/youtube.svg": "./src/assets/images/platforms/colored/youtube.svg",
	"./custom.svg": "./src/assets/images/platforms/custom.svg",
	"./cybergame.svg": "./src/assets/images/platforms/cybergame.svg",
	"./discord.png": "./src/assets/images/platforms/discord.png",
	"./djlive.png": "./src/assets/images/platforms/djlive.png",
	"./dlive.svg": "./src/assets/images/platforms/dlive.svg",
	"./facebook-live.svg": "./src/assets/images/platforms/facebook-live.svg",
	"./fb copy.svg": "./src/assets/images/platforms/fb copy.svg",
	"./fb.svg": "./src/assets/images/platforms/fb.svg",
	"./fc2.svg": "./src/assets/images/platforms/fc2.svg",
	"./gg.svg": "./src/assets/images/platforms/gg.svg",
	"./instagib.svg": "./src/assets/images/platforms/instagib.svg",
	"./instagram.svg": "./src/assets/images/platforms/instagram.svg",
	"./lahzenegar.svg": "./src/assets/images/platforms/lahzenegar.svg",
	"./linkedin.svg": "./src/assets/images/platforms/linkedin.svg",
	"./liveedu.svg": "./src/assets/images/platforms/liveedu.svg",
	"./livehouse.svg": "./src/assets/images/platforms/livehouse.svg",
	"./livestream.svg": "./src/assets/images/platforms/livestream.svg",
	"./meridix.svg": "./src/assets/images/platforms/meridix.svg",
	"./mixcloud.svg": "./src/assets/images/platforms/mixcloud.svg",
	"./mixer.svg": "./src/assets/images/platforms/mixer.svg",
	"./mobcrush.svg": "./src/assets/images/platforms/mobcrush.svg",
	"./nimotv.svg": "./src/assets/images/platforms/nimotv.svg",
	"./periscope.png": "./src/assets/images/platforms/periscope.png",
	"./phonelivestreaming.svg": "./src/assets/images/platforms/phonelivestreaming.svg",
	"./picartotv.svg": "./src/assets/images/platforms/picartotv.svg",
	"./sportscastr.svg": "./src/assets/images/platforms/sportscastr.svg",
	"./steam.svg": "./src/assets/images/platforms/steam.svg",
	"./stream-logo-light.png": "./src/assets/images/platforms/stream-logo-light.png",
	"./switchboard.svg": "./src/assets/images/platforms/switchboard.svg",
	"./thetatv.svg": "./src/assets/images/platforms/thetatv.svg",
	"./tiktok.svg": "./src/assets/images/platforms/tiktok.svg",
	"./trovo.svg": "./src/assets/images/platforms/trovo.svg",
	"./twitch.svg": "./src/assets/images/platforms/twitch.svg",
	"./twitter.svg": "./src/assets/images/platforms/twitter.svg",
	"./ustream.svg": "./src/assets/images/platforms/ustream.svg",
	"./vaperstv.svg": "./src/assets/images/platforms/vaperstv.svg",
	"./vaughnlive.svg": "./src/assets/images/platforms/vaughnlive.svg",
	"./vimeo.svg": "./src/assets/images/platforms/vimeo.svg",
	"./vimmtv.svg": "./src/assets/images/platforms/vimmtv.svg",
	"./vk.svg": "./src/assets/images/platforms/vk.svg",
	"./wasd.svg": "./src/assets/images/platforms/wasd.svg",
	"./webtv.svg": "./src/assets/images/platforms/webtv.svg",
	"./x.svg": "./src/assets/images/platforms/x.svg",
	"./younow.svg": "./src/assets/images/platforms/younow.svg",
	"./youtube.svg": "./src/assets/images/platforms/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/platforms sync recursive ^\\.\\/.*$";